import { cloneDeep } from 'lodash';
import { transformTextDataToLowLever } from '@meitu/saas-editor-core-next/es/utils/transform-kit';
import { traverseTree } from '@meitu/saas-editor-core-next/es/utils/tree-kit';
import { parseClientLayersToServer } from '@meitu/saas-editor-core-next/es/version-parse/client-to-server/parse-client-layers-to-server';
import {
    LayerType,
    StretchOptionType,
    type IImageLayerProps,
    type ILayerProps,
} from '@meitu/saas-editor-core-next/es/version-types';

export const MAX_FILE_SIZE = 600 * 1024 * 1024;

export const transferClientLayersToServerLayers = (clientLayers: ILayerProps[]) => {
    const transformTextData = (layer: any) => {
        layer.data = transformTextDataToLowLever(layer.data);
    };

    const lowLayers = clientLayers.map((layer) => {
        // 转换数据再进行保存，但是不要直接修改原始图层的数据
        const tempLayer = cloneDeep(layer);
        tempLayer.materialIds = {} as any;
        if (tempLayer.layerType === LayerType.TEXT_LAYER) {
            transformTextData(tempLayer);
            return tempLayer;
        } else if (tempLayer.layerType === LayerType.IMAGE_LAYER && (tempLayer.data as IImageLayerProps).maskURL) {
            (tempLayer.data as IImageLayerProps).stretchOption = StretchOptionType.cover;
            return tempLayer;
        } else if (tempLayer.layerType === LayerType.GROUP_LAYER) {
            traverseTree(tempLayer, (tempLayer: any) => {
                if (tempLayer.layerType === LayerType.TEXT_LAYER) {
                    transformTextData(tempLayer);
                }
            });

            return tempLayer;
        } else {
            return tempLayer;
        }
    });

    const { layers: resultLayers, version: currentVersion } = parseClientLayersToServer(lowLayers, true);

    return { layers: resultLayers, version: currentVersion };
};
